import React, { createRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { getImgixUrl } from '../../../../../../helpers';
import {
  CallToActionConfigProps,
  StyledCallToAction,
  StyledHeading,
  StyledParagraph,
} from '../../../sharedComponents';
import { Hr, PhotoGallery } from '../../innerComponents';

export const ZoomableImageDefault = (props) => {
  const { title, alt, titleSize, text, ctaConfig, path, tenantId, moduleType } =
    props;
  const themeConfig = useContext(ThemeContext);
  const dStyles = themeConfig?.module?.dStyles;
  const vStyles = themeConfig?.module?.vStyles;
  const { xs, sm, offset } = dStyles?.contentGrid;
  const {
    elements: {
      callToAction: { settings: { mode: callToActionMode } = {} } = {},
    } = {},
  } = vStyles;
  const componentRef = createRef();
  const imagePath = getImgixUrl(tenantId, path);

  return (
    <div
      className="container"
      ref={componentRef}
      data-testid="zoomable-image-default-container"
    >
      <div className="row">
        <div className={`col-xs-${xs} text-center`}>
          <StyledHeading
            content={title}
            as={titleSize}
            displayStyles={dStyles}
            visualStyles={vStyles}
          />
        </div>
      </div>
      <Hr />
      <div className="row">
        <div className={`col-xs-${xs} col-sm-${sm} col-sm-offset-${offset}`}>
          <StyledParagraph
            content={text}
            displayStyles={dStyles}
            visualStyles={vStyles}
          />
        </div>
        <div
          className={`col-xs-${xs} col-sm-${sm} col-sm-offset-${offset} zoomable-image-photo-gallery-wrapper`}
        >
          {imagePath && (
            <PhotoGallery
              title={title}
              alt={alt}
              componentRef={componentRef}
              imagePath={imagePath}
              data-testid="zoomable-image-gallery"
            />
          )}
        </div>
      </div>
      {ctaConfig.shown && (
        <div className="row" data-testid="zoomable-image-cta-button">
          <div className={`col-xs-${xs} text-center`}>
            <StyledCallToAction
              ctaConfig={ctaConfig}
              mode={callToActionMode}
              displayStyles={dStyles}
              visualStyles={vStyles}
              ga4={{
                module_type: moduleType,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

ZoomableImageDefault.propTypes = {
  title: PropTypes.string,
  titleSize: PropTypes.string,
  text: PropTypes.string,
  vStyles: PropTypes.object,
  dStyles: PropTypes.object,
  ctaConfig: CallToActionConfigProps,
  path: PropTypes.string,
  tenantId: PropTypes.string,
  moduleType: PropTypes.string,
};
